import React from "react";
import { useTranslation } from "react-i18next";
import { Table } from "reactstrap";
import PrintFooter from "../../../common/component/PrintFooter";
import { SafeBig } from "../../../common/function/safeBig";
import { showCurrency, showDate, showQty } from "../../../common/function/showValueHelper";
import changeCase from "change-case";

type DeliveryReportPrintAnjProps = {
    data: any;
    companyInfo: any
};

function getData(companyInfo: any, key: string) {
    let obj = companyInfo.find((val: any) => val.key === key);
    return obj ? obj.value : "";
}

const DeliveryReportPrintAnj = React.memo(
    ({ data, companyInfo }: DeliveryReportPrintAnjProps) => {
        const { t } = useTranslation();
        if (data == null) return <p>No Data</p>;
        let totalQty = SafeBig(0);
        let columns = data.detailList.map((obj: any, index: number) => {
            totalQty = totalQty.plus(SafeBig(obj.qty ?? 0));
            return (
                <tr key={"detail-" + index}>
                    <td className="rowNo">{index + 1}</td>
                    <td>{obj.productName ?? obj.product.name}</td>
                    <td className="qty">
                        {obj.unit == null ? (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.product?.unit?.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.unit.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </td>
                </tr>
            );
        });
        return (
            <Table className="ra-table-print">
                <thead>
                    <tr style={{ marginBottom: "10px" }}>
                        <th>
                            <b>{changeCase.upper(t("common.deliveryReport"))}</b>
                        </th>
                        <th>
                            <b>
                                {t("common.date")}: {showDate(data.documentDate)}
                            </b>
                        </th>
                    </tr>
                    <tr>
                        <th style={{ width: "60%" }}>
                            <b>{data.key}</b> <br />
                            <p>{getData(companyInfo, "nama-perusahaan")} <br />
                            {getData(companyInfo, "alamat-perusahaan")}</p>
                        </th>
                        <th>
                            {t("common.recipient")}: <br />
                            {data.customer.name} <br/> {data.customAddress}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <Table className="ra-table-detail-print">
                                <thead>
                                    <tr>
                                        <th className="rowNo">#</th>
                                        <th>{t("common.product")}</th>
                                        <th className="qty">{t("common.qty")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {columns}
                                    <tr>
                                        <td colSpan={2} style={{ textAlign: "right" }}>
                                            {t("common.totalQty")}
                                        </td>
                                        <td>{showCurrency(totalQty.toString(), 2)}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <PrintFooter footerType="deliveryReport" />
                        </td>
                    </tr>
                </tbody>
            </Table>
        );
    }
);

export default DeliveryReportPrintAnj;
